// extracted by mini-css-extract-plugin
export default {"footer":"redeemFooter_footer__hMOou"};